export default "__VITE_ASSET__DuF6dyII__"